export default {
  tagline: 'Ověřené klíče. Okamžité doručení. Žádné kecy. Nový standard digitální distribuce.',
  shop: 'OBCHOD',
  legal: 'PRÁVNÍ',
  help: 'NÁPOVĚDA',
  marketplace: 'Tržiště',
  catalog: 'Katalog',
  articles: 'Články',
  terms: 'Podmínky',
  privacy: 'Soukromí',
  cookies: 'Cookies',
  support: 'Podpora',
  faq: 'FAQ',
  language: 'Jazyk',
  legalLine:
    'PixelKey Placeholder Ltd. Placeholder adresa, Riga, Lotyšsko · DIČ: LV40012345678 · Reg. č.: 40012345678',
  copyright: '© 2026 PixelKey. Herní klíče, doručené férově.',
};
